explainerPlaylistEdit